import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import MsgDialog from './msg-dialog'
import * as utils from '@utils'

class SingleConfirmMsgDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'SingleConfirmMsgDialog')
        }
    }

    state = {
        type: '',
        msg: '',
        buttons: [],
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset(inputs) {
        this.setState({
            type: inputs.type,
            msg: inputs.msg,
            buttons: [
                {
                    text: this.t('confirm'),
                    action: () => {
                        this.closeDialog()
                    },
                },
            ],
        })
    }

    OpenDialog(inputs) {
        this.reset(inputs)
        this.dialog.OpenDialog()
    }

    closeDialog() {
        this.dialog.closeDialog()
    }

    render() {
        return <MsgDialog onRef={(ref) => (this.dialog = ref)} type={this.state.type} msg={this.state.msg} buttons={this.state.buttons} />
    }
}

const styles = (_theme) => {
    return {}
}

SingleConfirmMsgDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
}

export default hoc(styles)(SingleConfirmMsgDialog)
